<script setup>
import { useSlots } from 'vue';

// eslint-disable-next-line no-undef
const props = defineProps({
    title: {
        type: String,
        required: true,
    },
});

const slot = useSlots();
</script>

<template>
    <section>
        <header class="tw-w-2/3 tw-mx-auto">
            <h4 class="tw-text-secondary !tw-text-[2em] tw-font-neue-kabel-bold tw-flex tw-items-center !tw-mb-6">
                {{ props.title }}
            </h4>
        </header>

        <slot />

        <footer v-if="slot.footer" class="tw-w-2/3 tw-mx-auto tw-text-right tw-px-12 tw-mt-7">
            <slot name="footer" />
        </footer>
    </section>
</template>
